import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';
import { INVOICE_PATH } from 'domain/finance/invoice/useInvoiceService';

export const useInvoiceUrl = () => {
  const baseUrls = useEntityUrl({ baseLink: INVOICE_PATH });

  return { ...baseUrls, getCopyEntityUrl: (id?: string): string => `${baseUrls.getSingleEntityUrl(id)}/copy` };
};

export const useInvoiceId = () => useParams<Dictionary<string>>().id!;
